<div class="row">
    <div class="col">
        <div class="blocks m-3 pt-0 px-0">
            <form [formGroup]="formBuilder">

                <!--main input-->
                <div class="row px-3">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_title" class="form-label label-fw">
                                {{'pages.footer-entity.footer-entity-edit.form.label-fields.title' | translate}}
                                *
                            </label>
                            <input  formControlName="title" name="title" 
                                    [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.title.errors}"
                                    type="text" class="form-control form-fw "
                                    id="field_title" placeholder="Titolo">
                            <div class="invalid-feedback" *ngIf="form.touched">
                                <span *ngIf="formControls.title.errors && formControls.title.errors?.required">
                                    {{'pages.footer-entity.footer-entity-edit.form.errors.title-required' | translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_index" class="form-label label-fw">
                                {{'pages.footer-entity.footer-entity-edit.form.label-fields.index' | translate}}  
                                *
                            </label>
                            <input  formControlName="index" name="index" 
                                    [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.index.errors}"
                                    type="number" class="form-control form-fw "
                                    id="field_index" placeholder="Posizione">
                            <div class="invalid-feedback" *ngIf="form.touched">
                                <span *ngIf="formControls.title.errors && formControls.title.errors?.required">
                                    {{'pages.footer-entity.footer-entity-edit.form.errors.index-required' | translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>


                <!--Scelta tipo-->
                <div class="row pt-4 px-3">
                    <div class="col-12 m-3">
                        <label for="exampleFormControlInput1" class="form-label label-fw">
                            {{'pages.footer-entity.footer-entity-edit.form.label-fields.menuItemsType' | translate}}
                        </label>
                        <br>
                        <div class="form-check form-check-inline mx-3">
                            <input formControlName="menuItemsType" name="menuItemsType" class="form-check-input"
                                type="radio" id="inlineRadio1" value="LINK" checked>
                            <label class="form-check-label" for="inlineRadio1">
                                {{'pages.footer-entity.footer-entity-edit.form.label-fields.menuItemsType-LINK' | translate}}
                            </label>
                        </div>
                        <div class="form-check form-check-inline mx-3">
                            <input formControlName="menuItemsType" name="menuItemsType" class="form-check-input"
                                type="radio" id="inlineRadio2" value="LIST">
                            <label class="form-check-label" for="inlineRadio2">
                                {{'pages.footer-entity.footer-entity-edit.form.label-fields.menuItemsType-LIST' | translate}}
                            </label>
                        </div>
                    </div>
                </div>



                <!-- LINK -->
                <div class="row pt-4 px-3" [hidden]="formControls.menuItemsType.value != 'LINK'">
                    <div class="col-12">
                        <div class="m-3">
                            <label for="field_externalLink" class="form-label label-fw">
                                {{'pages.footer-entity.footer-entity-edit.form.label-fields.externalLink' | translate}}
                            </label>
                            <input formControlName="externalLink" name="externalLink" type="text"
                                class="form-control form-fw " id="field_externalLink" placeholder="Link">
                        </div>
                    </div>
                </div>


                <!-- LIST -->
                <div class="row pt-4 px-3" [hidden]="formControls.menuItemsType.value != 'LIST'">
                    <div class="col-12">
                        <div class="m-3">
                            <app-footer-entity-items [inputIdMenu]="id" [inputMenuItems]="menuItems"></app-footer-entity-items>
                        </div>
                    </div> 
                </div>



            </form>

            <!-- Modal footer -->
            <div class="modal-foot">
                <div class="row my-3 text-center">
                    <button type="button" class="btn btn-fw text me-3" 
                        [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false " 
                        (click)="clickButtonSave()">
                        {{'pages.footer-entity.footer-entity-edit.buttons.save' | translate}}
                    </button>
                    <button type="button" class="btn btn-outline-fw text"
                        (click)="clickButtonCancel()">
                        {{'pages.footer-entity.footer-entity-edit.buttons.cancel' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>